<template>
    <div class="drawer">
        <el-drawer
            :title="detailData.title"
            :visible.sync="detailParam.visible"
            :size="detailParam.row.customer_id ? '840px' : '520px'"
            :close-on-press-escape="false"
            :wrapperClosable="false"
        >
            <div class="process">
                <ul class="process-wrapper">
                    <template v-for="(value, index) in $store.state.customerInfo.process">
                        <li :key="index" class="process-item" @click="QuickProcess(index)">
                            <span
                                :class="
                                    processData.index >= index
                                        ? 'process-item-default process-item-active'
                                        : 'process-item-default'
                                "
                                >{{ value }}</span
                            >
                        </li>
                    </template>
                </ul>
                <template v-if="detailData.state.active == 1">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-circle-plus"
                        class="process-button"
                        @click="DetailFollow"
                        >跟进</el-button
                    >
                </template>
                <template v-if="detailData.state.active == 2">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-circle-plus"
                        class="process-button"
                        @click="DetailTask"
                        >任务</el-button
                    >
                </template>
                <template v-if="detailData.state.active == 3">
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-circle-plus"
                        class="process-button"
                        @click="DetailOrder"
                        >订单</el-button
                    >
                </template>
            </div>
            <div class="drawer-wrapper">
                <div class="drawer-main" v-loading="detailData.loading.main">
                    <div class="drawer-model">
                        <div class="drawer-header">
                            <div class="drawer-title">基本信息</div>
                            <template v-if="detailData.row.display">
                                <template v-if="detailData.state.edit">
                                    <el-button size="mini" @click="detailData.state.edit = false">取消</el-button>
                                    <el-button
                                        type="primary"
                                        size="mini"
                                        :loading="detailData.loading.submit"
                                        @click="SubmitCustomer('detailData')"
                                        >保存</el-button
                                    >
                                </template>
                                <template v-else>
                                    <el-button size="mini" @click="EditCustomer">修改</el-button>
                                </template>
                            </template>
                        </div>
                        <div class="drawer-body">
                            <el-form
                                :model="detailData"
                                ref="detailData"
                                label-position="left"
                                label-width="80px"
                                size="small"
                            >
                                <el-form-item
                                    label="名称"
                                    prop="row.name"
                                    :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                                >
                                    <template v-if="detailData.state.edit">
                                        <el-input
                                            v-model="detailData.row.name"
                                            placeholder="公司名称 / 门店 / 养殖场 / 个体户"
                                        ></el-input>
                                    </template>
                                    <template v-else>{{ detailData.row.name }}</template>
                                </el-form-item>
                                <el-form-item
                                    label="地址"
                                    prop="row.area"
                                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                                >
                                    <template v-if="detailData.state.edit">
                                        <el-cascader
                                            v-model="detailData.row.area"
                                            :options="regionData.list"
                                            filterable
                                            clearable
                                        ></el-cascader>
                                    </template>
                                    <template v-else
                                        >{{ detailData.row.province }}{{ detailData.row.city }}{{ detailData.row.county
                                        }}{{ detailData.row.address }}</template
                                    >
                                </el-form-item>
                                <el-form-item v-if="detailData.state.edit">
                                    <el-input v-model="detailData.row.address" placeholder="详细地址"></el-input>
                                </el-form-item>
                                <el-form-item label="类型">
                                    <template v-if="detailData.state.edit">
                                        <el-select v-model="detailData.row.customer_type_id">
                                            <el-option
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                                v-for="item in typeData.list"
                                            ></el-option>
                                        </el-select>
                                    </template>
                                    <template v-else>{{
                                        (detailData.row.customer_type && detailData.row.customer_type.name) || '---'
                                    }}</template>
                                </el-form-item>
                                <el-form-item label="来源">
                                    <template v-if="detailData.state.edit">
                                        <el-select v-model="detailData.row.customer_source_id">
                                            <el-option
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                                v-for="item in sourceData.list"
                                            ></el-option>
                                        </el-select>
                                    </template>
                                    <template v-else>{{
                                        (detailData.row.customer_source && detailData.row.customer_source.name) || '---'
                                    }}</template>
                                </el-form-item>
                                <el-form-item label="级别">
                                    <template v-if="detailData.state.edit">
                                        <el-select v-model="detailData.row.customer_level_id">
                                            <el-option
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                                v-for="item in levelData.list"
                                            ></el-option>
                                        </el-select>
                                    </template>
                                    <template v-else>{{
                                        (detailData.row.customer_level && detailData.row.customer_level.name) || '---'
                                    }}</template>
                                </el-form-item>
                                <el-form-item label="备注">
                                    <template v-if="detailData.state.edit">
                                        <el-input
                                            type="textarea"
                                            :rows="4"
                                            maxlength="60"
                                            show-word-limit
                                            v-model="detailData.row.memo"
                                        ></el-input>
                                    </template>
                                    <template v-else>{{ detailData.row.memo || '---' }}</template>
                                </el-form-item>
                                <el-divider></el-divider>
                                <el-form-item
                                    label="姓名"
                                    prop="row.contact_name"
                                    :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                                >
                                    <template v-if="detailData.state.edit">
                                        <el-input v-model="detailData.row.contact_name" placeholder="请输入"></el-input>
                                    </template>
                                    <template v-else>{{ detailData.row.contact_name }}</template>
                                </el-form-item>
                                <el-form-item
                                    label="手机号"
                                    prop="row.contact_mobilephone"
                                    :rules="[
                                        { required: true, message: ' ', trigger: 'blur' },
                                        {
                                            pattern: /^1[3456789]\d{9}$/,
                                            message: '手机号码格式错误，请重新填写',
                                            trigger: 'blur'
                                        }
                                    ]"
                                >
                                    <template v-if="detailData.state.edit">
                                        <el-input
                                            v-model.number="detailData.row.contact_mobilephone"
                                            maxlength="11"
                                            placeholder="请输入"
                                        ></el-input>
                                    </template>
                                    <template v-else
                                        >{{ detailData.row.contact_mobilephone }}
                                        <span
                                            class="t-primary t-pointer"
                                            @click="GetCall(detailData.row.contact_mobilephone)"
                                            >呼叫</span
                                        ></template
                                    >
                                </el-form-item>
                                <el-form-item
                                    label="座机："
                                    prop="row.contact_telephone"
                                    :rules="[
                                        {
                                            pattern: /^0\d{9,11}$/,
                                            message: '座机号码格式错误，中间不能有任何空格或字符',
                                            trigger: 'blur'
                                        }
                                    ]"
                                >
                                    <template v-if="detailData.state.edit">
                                        <el-input
                                            v-model="detailData.row.contact_telephone"
                                            placeholder="请输入"
                                        ></el-input>
                                    </template>
                                    <template v-else
                                        >{{ detailData.row.contact_telephone || '---' }}
                                        <span
                                            class="t-primary t-pointer"
                                            @click="GetCall(detailData.row.contact_telephone)"
                                            v-if="detailData.row.contact_telephone"
                                            >呼叫</span
                                        ></template
                                    >
                                </el-form-item>
                                <el-form-item label="职务">
                                    <template v-if="detailData.state.edit">
                                        <el-input v-model="detailData.row.contact_post" placeholder="请输入"></el-input>
                                    </template>
                                    <template v-else>{{ detailData.row.contact_post || '---' }}</template>
                                </el-form-item>
                                <el-form-item label="微信号">
                                    <template v-if="detailData.state.edit">
                                        <el-input
                                            v-model="detailData.row.contact_weixin"
                                            placeholder="请输入"
                                        ></el-input>
                                    </template>
                                    <template v-else>{{ detailData.row.contact_weixin || '---' }}</template>
                                </el-form-item>
                                <el-form-item label="QQ号">
                                    <template v-if="detailData.state.edit">
                                        <el-input
                                            v-model.number="detailData.row.contact_qq"
                                            placeholder="请输入"
                                        ></el-input>
                                    </template>
                                    <template v-else>{{ detailData.row.contact_qq || '---' }}</template>
                                </el-form-item>
                                <el-form-item label="旺旺号">
                                    <template v-if="detailData.state.edit">
                                        <el-input
                                            v-model="detailData.row.contact_wangwang"
                                            placeholder="请输入"
                                        ></el-input>
                                    </template>
                                    <template v-else>{{ detailData.row.contact_wangwang || '---' }}</template>
                                </el-form-item>
                                <el-form-item label="邮箱">
                                    <template v-if="detailData.state.edit">
                                        <el-input
                                            v-model="detailData.row.contact_email"
                                            placeholder="请输入"
                                        ></el-input>
                                    </template>
                                    <template v-else>{{ detailData.row.contact_email || '---' }}</template>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
                <div class="drawer-side" v-loading="detailData.loading.side">
                    <div class="drawer-model">
                        <el-tabs v-model="detailData.state.active">
                            <el-tab-pane key="1" label="成长记录" name="1">
                                <template v-if="detailData.state.follow">
                                    <div class="drawer-follow">
                                        <template v-for="(row, index) in $store.state.customerInfo.state">
                                            <el-tag
                                                :key="index"
                                                size="mini"
                                                type="info"
                                                @click="followData.row.communicate_record = row.value"
                                                >{{ row.key }}</el-tag
                                            >
                                        </template>
                                        <el-input
                                            type="textarea"
                                            :rows="2"
                                            maxlength="200"
                                            show-word-limit
                                            placeholder="跟进内容【有效？无效？】"
                                            v-model="followData.row.communicate_record"
                                        ></el-input>
                                        <div class="t-right">
                                            <el-button size="mini" @click="detailData.state.follow = false"
                                                >取 消</el-button
                                            >
                                            <el-button type="primary" size="mini" @click="SubmitFollow"
                                                >提 交</el-button
                                            >
                                        </div>
                                    </div>
                                </template>
                                <div class="drawer-body">
                                    <template v-for="(row, index) in growingData.list">
                                        <div
                                            :key="index"
                                            :class="row.type === 4 ? 'drawer-step drawer-order' : 'drawer-step'"
                                        >
                                            <!-- 新增修改客户 -->
                                            <template v-if="row.type === 1 || row.type === 2">
                                                <div class="drawer-body-head">
                                                    <!-- 新增客户 -->
                                                    <template v-if="row.type === 1">
                                                        <svg t="1599547955135" viewBox="0 0 1024 1024" height="26">
                                                            <path
                                                                fill="#13BF86"
                                                                d="M711.3728 540.4672H540.4672v170.9056c0 15.6672-12.6976 28.4672-28.4672 28.4672-15.6672 0-28.4672-12.8-28.4672-28.4672V540.4672H312.6272c-15.6672 0-28.4672-12.6976-28.4672-28.4672 0-15.6672 12.8-28.4672 28.4672-28.4672h170.9056V312.6272c0-15.6672 12.6976-28.4672 28.4672-28.4672 15.6672 0 28.4672 12.8 28.4672 28.4672v170.9056h170.9056c15.6672 0 28.4672 12.6976 28.4672 28.4672-0.1024 15.6672-12.9024 28.4672-28.4672 28.4672M512 56.9344c-251.2896 0-455.0656 203.776-455.0656 455.0656s203.776 455.0656 455.0656 455.0656 455.0656-203.776 455.0656-455.0656S763.2896 56.9344 512 56.9344"
                                                            />
                                                        </svg>
                                                    </template>
                                                    <!-- 修改客户 -->
                                                    <template v-if="row.type === 2">
                                                        <svg t="1599547955135" viewBox="0 0 1024 1024" height="26">
                                                            <path
                                                                fill="#13BF86"
                                                                d="M512 967.0656c-251.392 0-455.0656-203.776-455.0656-455.0656S260.608 56.9344 512 56.9344s455.0656 203.776 455.0656 455.0656S763.392 967.0656 512 967.0656zM289.8944 515.3792l140.9024 131.3792c10.3424 9.6256 26.8288 10.0352 36.9664 0.7168L791.04 346.112c6.7584-6.3488 7.2704-15.872 0.8192-21.9136l-7.3728-6.9632c-5.9392-5.5296-16.5888-5.9392-23.3472-0.8192L459.8784 544.5632c-5.632 4.3008-15.9744 4.7104-22.016 1.024l-113.9712-71.0656c-7.168-4.4032-17.2032-2.8672-22.6304 3.4816L288.1536 493.568c-5.632 6.656-4.608 15.872 1.7408 21.8112z"
                                                            />
                                                        </svg>
                                                    </template>
                                                    <div class="drawer-body-title">
                                                        {{ row.type === 1 ? '新增客户' : '修改客户' }}
                                                    </div>
                                                </div>
                                                <div class="drawer-body-main">
                                                    <p>姓名：{{ row.info.name }}</p>
                                                    <p>
                                                        来源：{{
                                                            row.info.customer_source
                                                                ? row.info.customer_source.name || '--'
                                                                : '--'
                                                        }}
                                                    </p>
                                                    <p>
                                                        类型：{{
                                                            row.info.customer_type
                                                                ? row.info.customer_type.name || '--'
                                                                : '--'
                                                        }}
                                                    </p>
                                                    <p>
                                                        级别：{{
                                                            row.info.customer_level
                                                                ? row.info.customer_level.name || '--'
                                                                : '--'
                                                        }}
                                                    </p>
                                                    <p>
                                                        地址：{{ row.info.province }}{{ row.info.city
                                                        }}{{ row.info.county }}{{ row.info.address }}
                                                    </p>
                                                    <p>备注：{{ row.info.memo || '--' }}</p>
                                                    <p>联系人：{{ row.info.contact_name }}</p>
                                                    <p>手机：{{ row.info.contact_mobilephone }}</p>
                                                    <p>座机：{{ row.info.contact_telephone }}</p>
                                                    <p>职务：{{ row.info.contact_post || '--' }}</p>
                                                    <p>微信：{{ row.info.contact_weixin || '--' }}</p>
                                                    <p>QQ：{{ row.info.contact_qq || '--' }}</p>
                                                    <p>旺旺：{{ row.info.contact_wangwang || '--' }}</p>
                                                    <p>邮箱：{{ row.info.contact_email || '--' }}</p>
                                                    <div class="drawer-body-description t-small">
                                                        {{ row.operator }} · {{ row.created_at }}
                                                    </div>
                                                </div>
                                            </template>
                                            <!-- 客户跟进 -->
                                            <template v-if="row.type === 3">
                                                <div class="drawer-body-head">
                                                    <svg viewBox="0 0 1024 1024" height="26">
                                                        <path
                                                            fill="#5757d9"
                                                            d="M512 967.0656c-251.392 0-455.0656-203.776-455.0656-455.0656S260.608 56.9344 512 56.9344s455.0656 203.776 455.0656 455.0656S763.392 967.0656 512 967.0656z m0-426.5984V312.9344c0-15.6672-12.6976-28.4672-28.4672-28.4672s-28.4672 12.6976-28.4672 28.4672v256c0 15.6672 12.6976 28.4672 28.4672 28.4672h256c15.6672 0 28.4672-12.6976 28.4672-28.4672 0-15.6672-12.6976-28.4672-28.4672-28.4672H512z"
                                                        />
                                                    </svg>
                                                    <div class="drawer-body-title">
                                                        {{ row.info }}
                                                    </div>
                                                </div>
                                                <div class="drawer-body-main">
                                                    <div class="drawer-body-description t-small">
                                                        {{ row.operator }} · {{ row.created_at }}
                                                    </div>
                                                </div>
                                            </template>
                                            <!-- 客户订单 -->
                                            <template v-if="row.type === 4 && row.info.id">
                                                <div class="drawer-body-head">
                                                    <svg viewBox="0 0 1024 1024" height="26">
                                                        <path
                                                            fill="#F24957"
                                                            d="M512 967.0656c-251.392 0-455.0656-203.776-455.0656-455.0656S260.608 56.9344 512 56.9344s455.0656 203.776 455.0656 455.0656S763.392 967.0656 512 967.0656z m-57.344-540.3648h-84.8896c-15.6672 0-28.4672 12.6976-28.4672 28.4672 0 15.6672 12.6976 28.4672 28.4672 28.4672h113.7664v85.2992H369.7664c-15.6672 0-28.4672 12.6976-28.4672 28.4672 0 15.6672 12.6976 28.4672 28.4672 28.4672h113.7664v113.7664c0 15.6672 12.6976 28.4672 28.4672 28.4672s28.4672-12.6976 28.4672-28.4672V625.7664h113.7664c15.6672 0 28.4672-12.6976 28.4672-28.4672 0-15.6672-12.6976-28.4672-28.4672-28.4672H540.4672v-85.2992h113.7664c15.6672 0 28.4672-12.6976 28.4672-28.4672 0-15.6672-12.6976-28.4672-28.4672-28.4672h-82.944l81.92-81.92c11.0592-11.0592 11.0592-29.0816 0-40.2432-11.0592-11.0592-29.0816-11.0592-40.2432 0L513.024 404.48l-99.9424-99.9424c-11.0592-11.0592-29.0816-11.0592-40.2432 0-11.0592 11.0592-11.0592 29.0816 0 40.2432l81.8176 81.92z"
                                                        />
                                                    </svg>
                                                    <div class="drawer-body-title">
                                                        {{ row.info.order_no }}
                                                    </div>
                                                    <div class="drawer-body-time t-r">
                                                        {{ row.info.created_at }}
                                                    </div>
                                                </div>
                                                <div class="drawer-body-main">
                                                    <template
                                                        v-if="
                                                            $store.state.userInfo.identity === 1 ||
                                                            $store.state.userInfo.id === detailData.row.owner_id ||
                                                            $store.state.userInfo.id === row.info.owner_id ||
                                                            $store.state.userInfo.id === row.info.order_user.id
                                                        "
                                                    >
                                                        <el-table
                                                            :data="row.info.details"
                                                            style="width: 100%"
                                                            class="el-table__justify"
                                                        >
                                                            <el-table-column label="产品">
                                                                <template slot-scope="scope"
                                                                    >{{ scope.row.product.name }}（{{
                                                                        scope.row.product.barcode
                                                                    }}）</template
                                                                >
                                                            </el-table-column>
                                                            <el-table-column label="单价" width="90">
                                                                <template slot-scope="scope">{{
                                                                    scope.row.price | $separator
                                                                }}</template>
                                                            </el-table-column>
                                                            <el-table-column label="数量" width="60">
                                                                <template slot-scope="scope"
                                                                    >{{ scope.row.num
                                                                    }}{{ scope.row.unit_title }}</template
                                                                >
                                                            </el-table-column>
                                                        </el-table>
                                                    </template>
                                                    <template v-else>
                                                        <el-table
                                                            :data="row.info.details"
                                                            style="width: 100%"
                                                            class="el-table__justify"
                                                        >
                                                            <el-table-column label="产品">
                                                                <template slot-scope="scope"
                                                                    >{{ scope.row.product.name }}（{{
                                                                        scope.row.product.barcode
                                                                    }}）</template
                                                                >
                                                            </el-table-column>
                                                            <el-table-column label="数量" width="90">
                                                                <template slot-scope="scope"
                                                                    >{{ scope.row.num
                                                                    }}{{ scope.row.unit_title }}</template
                                                                >
                                                            </el-table-column>
                                                        </el-table>
                                                    </template>
                                                    <div class="drawer-body-description t-small">
                                                        {{ row.info.order_user.name }} ·
                                                        {{ row.info.pay_id | $pay }}
                                                    </div>
                                                    <template v-if="row.info.memo">
                                                        <el-alert
                                                            :title="row.info.memo"
                                                            type="warning"
                                                            :closable="false"
                                                        ></el-alert>
                                                    </template>
                                                </div>
                                                <el-row class="drawer-body-foot">
                                                    <el-col :span="6">
                                                        <template v-if="row.info.deliver_type_id === 2">
                                                            <el-tag type="danger">延迟发货</el-tag>
                                                        </template>
                                                        <template v-else>
                                                            <el-tag
                                                                :type="
                                                                    row.info.order_status_id < 3
                                                                        ? 'info'
                                                                        : row.info.order_status_id === 3 ||
                                                                          row.info.order_status_id === 30 ||
                                                                          row.info.order_status_id === 41 ||
                                                                          row.info.order_status_id === 410
                                                                        ? 'danger'
                                                                        : null
                                                                "
                                                                >{{ row.info.order_status_id | $order }}</el-tag
                                                            >
                                                        </template>
                                                    </el-col>
                                                    <el-col :span="18" class="t-right">
                                                        <el-button
                                                            size="small"
                                                            type="primary"
                                                            @click="DetailOrder(row.info)"
                                                            >{{
                                                                row.info.order_status_id === 0 &&
                                                                ($store.state.userInfo.id === detailData.row.owner_id ||
                                                                    $store.state.userInfo.id === row.info.order_user.id)
                                                                    ? '修改订单'
                                                                    : '查看订单'
                                                            }}</el-button
                                                        >
                                                    </el-col>
                                                </el-row>
                                            </template>
                                            <template v-if="row.type > 4 && row.type < 9">
                                                <div class="drawer-body-head">
                                                    <svg viewBox="0 0 1024 1024" height="26">
                                                        <path
                                                            fill="#FFAA00"
                                                            d="M509.319372 1.072251C228.641508 1.072251 1.072251 228.603979 1.072251 509.319372c0 280.677864 227.569257 508.24712 508.247121 508.24712 280.677864 0 508.24712-227.569257 508.24712-508.24712C1017.566492 228.641508 790.034764 1.072251 509.319372 1.072251"
                                                        />
                                                        <path
                                                            fill="#FFFFFF"
                                                            d="M372.242764 646.948188l55.392503 57.558451a37.357236 37.357236 0 0 1 0 51.468063 34.097592 34.097592 0 0 1-49.570178 0l-112.38266-116.618053a36.322513 36.322513 0 0 1-12.641843-20.39422 37.485906 37.485906 0 0 1 9.199917-34.617633 34.220901 34.220901 0 0 1 30.811141-10.164943h438.513257c19.364859 0 35.094785 16.373277 35.094785 36.483351 0 20.104712-15.762094 36.445822-35.094785 36.445822l-359.289969-0.160838h-0.032168z m274.169299-275.252272l-55.392503-57.55845a37.357236 37.357236 0 0 1 0-51.473424 34.097592 34.097592 0 0 1 49.570178 0l112.388021 116.623413a36.360042 36.360042 0 0 1 12.641843 20.39422c2.862911 11.971686-0.193005 25.25688-9.199916 34.617634a34.258429 34.258429 0 0 1-30.816503 10.170304H287.073843c-19.364859 0-35.094785-16.378639-35.094785-36.483351 0-20.110073 15.762094-36.456545 35.094785-36.456545l359.306052 0.160838h0.032168z"
                                                        />
                                                    </svg>
                                                    <div class="drawer-body-title">
                                                        <!-- 转移到公海 -->
                                                        <template v-if="row.type === 5"
                                                            >将资源转移到<template v-if="row.info">{{
                                                                row.info.to
                                                            }}</template></template
                                                        >
                                                        <!-- 转移给销售 -->
                                                        <template v-if="row.type === 6"
                                                            >转移给<template v-if="row.info">{{
                                                                row.info.to
                                                            }}</template></template
                                                        >
                                                        <!-- 领取 -->
                                                        <template v-if="row.type === 7"
                                                            >从<template v-if="row.info">{{ row.info.from }}</template
                                                            >领取客户</template
                                                        >
                                                        <!-- 分配 -->
                                                        <template v-if="row.type === 8">分配客户</template>
                                                    </div>
                                                </div>
                                                <div class="drawer-body-main">
                                                    <div class="drawer-body-description t-small">
                                                        {{ row.operator }} · {{ row.created_at }}
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                    <div class="drawer-step">
                                        <div class="drawer-body-head">
                                            <svg viewBox="0 0 1024 1024" height="26">
                                                <path
                                                    fill="#909399"
                                                    d="M512 967.0656c-251.392 0-455.0656-203.776-455.0656-455.0656S260.608 56.9344 512 56.9344s455.0656 203.776 455.0656 455.0656S763.392 967.0656 512 967.0656z m0-398.1312c31.4368 0 56.9344-25.4976 56.9344-56.9344 0-31.4368-25.4976-56.9344-56.9344-56.9344s-56.9344 25.4976-56.9344 56.9344 25.4976 56.9344 56.9344 56.9344z m-227.5328 0c31.4368 0 56.9344-25.4976 56.9344-56.9344 0-31.4368-25.4976-56.9344-56.9344-56.9344-31.4368 0-56.9344 25.4976-56.9344 56.9344s25.4976 56.9344 56.9344 56.9344z m455.0656 0c31.4368 0 56.9344-25.4976 56.9344-56.9344 0-31.4368-25.4976-56.9344-56.9344-56.9344-31.4368 0-56.9344 25.4976-56.9344 56.9344s25.4976 56.9344 56.9344 56.9344z"
                                                />
                                            </svg>
                                            <div class="drawer-body-title">
                                                足够的了解客户，是我们不断提升的根本！
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane key="2" label="任务" name="2">
                                <div class="drawer-body">
                                    <template v-for="(row, index) in taskData.list">
                                        <div :key="index" class="drawer-task">
                                            <div class="drawer-body-head">
                                                <el-checkbox
                                                    :checked="row.status ? true : false"
                                                    @change="StateTask(row)"
                                                    >{{ row.visit_remind_memo }}</el-checkbox
                                                >
                                            </div>
                                            <div class="drawer-body-main">
                                                <span class="drawer-body-description t-small">{{
                                                    row.visit_remind_at
                                                }}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane key="3" label="订单" name="3">
                                <div class="drawer-body">
                                    <template v-if="!this.detailData.row.address">
                                        <el-alert
                                            type="error"
                                            title="地址不全，可能会影响快递发货，请提醒相关人员完善！"
                                            style="margin-bottom: 10px"
                                        ></el-alert>
                                    </template>
                                    <template v-for="(row, index) in orderData.list">
                                        <template v-if="row.id">
                                            <div :key="index" class="drawer-order">
                                                <div class="drawer-body-head">
                                                    <div class="drawer-body-title">
                                                        {{ row.order_no }}
                                                    </div>
                                                    <div class="drawer-body-time t-r">
                                                        {{ row.created_at | $moment }}
                                                    </div>
                                                </div>
                                                <div class="drawer-body-main">
                                                    <template
                                                        v-if="
                                                            $store.state.userInfo.identity === 1 ||
                                                                $store.state.userInfo.id === row.owner_id ||
                                                                $store.state.userInfo.id === row.order_user.id
                                                        "
                                                    >
                                                        <el-table
                                                            :data="row.details"
                                                            style="width: 100%"
                                                            class="el-table__justify"
                                                        >
                                                            <el-table-column label="产品">
                                                                <template slot-scope="scope"
                                                                    >{{ scope.row.product.name }}（{{
                                                                        scope.row.product.barcode
                                                                    }}）</template
                                                                >
                                                            </el-table-column>
                                                            <el-table-column label="单价" width="90">
                                                                <template slot-scope="scope">{{
                                                                    scope.row.price | $separator
                                                                }}</template>
                                                            </el-table-column>
                                                            <el-table-column label="数量" width="60">
                                                                <template slot-scope="scope"
                                                                    >{{ scope.row.num
                                                                    }}{{ scope.row.unit_title }}</template
                                                                >
                                                            </el-table-column>
                                                        </el-table>
                                                    </template>
                                                    <template v-else>
                                                        <el-table
                                                            :data="row.details"
                                                            style="width: 100%"
                                                            class="el-table__justify"
                                                        >
                                                            <el-table-column label="产品">
                                                                <template slot-scope="scope"
                                                                    >{{ scope.row.product.name }}（{{
                                                                        scope.row.product.barcode
                                                                    }}）</template
                                                                >
                                                            </el-table-column>
                                                            <el-table-column label="数量" width="90">
                                                                <template slot-scope="scope"
                                                                    >{{ scope.row.num
                                                                    }}{{ scope.row.unit_title }}</template
                                                                >
                                                            </el-table-column>
                                                        </el-table>
                                                    </template>
                                                    <div class="drawer-body-description t-small">
                                                        {{ row.order_user.name }} ·
                                                        {{ row.pay_id | $pay }}
                                                    </div>
                                                    <template v-if="row.memo">
                                                        <el-alert
                                                            :title="row.memo"
                                                            type="warning"
                                                            :closable="false"
                                                        ></el-alert>
                                                    </template>
                                                </div>
                                                <el-row class="drawer-body-foot">
                                                    <el-col :span="6">
                                                        <template v-if="row.deliver_type_id === 2">
                                                            <el-tag type="danger">延迟发货</el-tag>
                                                        </template>
                                                        <template v-else>
                                                            <el-tag
                                                                :type="
                                                                    row.order_status_id < 3
                                                                        ? 'info'
                                                                        : row.order_status_id === 3 ||
                                                                          row.order_status_id === 30 ||
                                                                          row.order_status_id === 41 ||
                                                                          row.order_status_id === 410
                                                                        ? 'danger'
                                                                        : null
                                                                "
                                                                >{{ row.order_status_id | $order }}</el-tag
                                                            >
                                                        </template>
                                                    </el-col>
                                                    <el-col :span="18" class="t-right">
                                                        <template
                                                            v-if="
                                                                $store.state.userInfo.id === detailData.row.owner_id ||
                                                                    $store.state.userInfo.id === row.order_user.id
                                                            "
                                                        >
                                                            <el-button-group>
                                                                <template v-if="row.order_status_id <= 2">
                                                                    <el-button
                                                                        size="small"
                                                                        @click="StateOrder(row.id, 3)"
                                                                        >取消</el-button
                                                                    >
                                                                </template>
                                                                <template v-if="row.order_status_id === 4">
                                                                    <el-button
                                                                        size="small"
                                                                        @click="StateOrder(row.id, 41)"
                                                                        >退货</el-button
                                                                    >
                                                                    <el-button
                                                                        size="small"
                                                                        @click="StateOrder(row.id, 40)"
                                                                        >收货</el-button
                                                                    >
                                                                </template>
                                                            </el-button-group>
                                                        </template>
                                                        <template v-if="row.order_status_id >= 4">
                                                            <el-button size="small" @click="DetailExpress(row)"
                                                                >查看物流</el-button
                                                            >
                                                        </template>
                                                        <el-button
                                                            size="small"
                                                            type="primary"
                                                            @click="DetailOrder(row)"
                                                            >{{
                                                                row.order_status_id === 0 &&
                                                                ($store.state.userInfo.id === detailData.row.owner_id ||
                                                                    $store.state.userInfo.id === row.order_user.id)
                                                                    ? '修改订单'
                                                                    : '查看订单'
                                                            }}</el-button
                                                        >
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
            </div>
        </el-drawer>

        <!-- 合作 -->
        <v-CooperationForm
            :detailParam="componentParam.cooperationForm"
            v-if="componentParam.cooperationForm.visible"
        />
        <!-- 任务 -->
        <v-VisitForm :detailParam="componentParam.visitForm" v-if="componentParam.visitForm.visible" />
        <!-- 订单 -->
        <v-OrderForm :detailParam="componentParam.orderForm" v-if="componentParam.orderForm.visible" />
        <v-OrderDetail :detailParam="componentParam.orderDetail" v-if="componentParam.orderDetail.visible" />
        <!-- 物流记录 -->
        <v-OrderExpress :detailParam="componentParam.orderExpress" v-if="componentParam.orderExpress.visible" />
    </div>
</template>

<script>
import { AreaData } from '@/plugin/Area'
import { CustomerData } from '@/plugin/Customer'
import CooperationForm from '@/components/cooperation/Form'
import VisitForm from '@/components/visit/Form'
import OrderForm from '@/components/order/Form'
import OrderDetail from '@/components/order/Detail'
import OrderExpress from '@/components/order/Express'
export default {
    components: {
        'v-CooperationForm': CooperationForm,
        'v-VisitForm': VisitForm,
        'v-OrderForm': OrderForm,
        'v-OrderDetail': OrderDetail,
        'v-OrderExpress': OrderExpress
    },
    inject: ['reload'],
    mixins: [AreaData, CustomerData],
    props: ['detailParam'],
    data() {
        return {
            sourceData: {
                list: []
            },
            typeData: {
                list: []
            },
            levelData: {
                list: []
            },
            processData: {
                index: -1
            },
            detailData: {
                loading: {
                    main: false,
                    side: false,
                    submit: false
                },
                title: '客户详情',
                state: {
                    active: '1',
                    edit: false,
                    follow: false,
                    task: false
                },
                row: {}
            },
            growingData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 20
                }
            },
            taskData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 100
                }
            },
            orderData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 100
                }
            },
            followData: {
                row: {
                    communicate_record: null
                }
            },
            componentParam: {
                cooperationForm: {},
                visitForm: {},
                orderForm: {},
                orderDetail: {},
                orderExpress: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {
            // 客户来源
            if (!this.sourceData.list.length) {
                this.GetSourceData({
                    order: 'DESC'
                }).then(res => {
                    this.sourceData.list = res.list
                })
            }
            // 客户类型
            if (!this.typeData.list.length) {
                this.GetTypeData().then(res => {
                    this.typeData.list = res.list
                })
            }
            // 客户级别
            if (!this.levelData.list.length) {
                this.GetLevelData().then(res => {
                    this.levelData.list = res.list
                })
            }
        })
    },
    mounted() {
        this.$nextTick(() => {
            this.GetCustomer()
            this.GetGrowing()
        })
    },
    watch: {
        'detailData.state.active'(val) {
            switch (val) {
                case '2':
                    this.GetTask()
                    break
                case '3':
                    this.GetOrder()
                    break
                default:
                    this.GetGrowing()
                    break
            }
        },
        'detailData.row.customer_type_id'(val) {
            if (this.detailData.state.edit && (val === 1 || val === 2)) {
                this.DetailCooperation()
            }
        }
    },
    methods: {
        // 快捷流程
        QuickProcess(index) {
            this.processData.index = index
            this.detailData.state.active = '1'
            this.SubmitFollow({
                communicate_record: this.$store.state.customerInfo.follow[index]
            })
        },
        // 成长记录
        DetailFollow() {
            if (this.detailData.state.active !== '1') {
                this.detailData.state.active = '1'
                this.detailData.state.follow = true
            } else {
                this.detailData.state.follow = !this.detailData.state.follow
            }
        },
        // 基本信息
        EditCustomer() {
            this.detailData.state.edit = true
        },
        GetCustomer() {
            this.detailData.loading.main = true
            this.$request({
                url: '/api/v1/customer/' + this.detailParam.row.customer_id
            }).then(res => {
                this.detailData.loading.main = false
                this.detailData.title = res.data.owner
                    ? this.detailData.title + '（' + res.data.owner + ')'
                    : this.detailData.title
                this.detailData.row = res.data
                this.detailData.row.area = [res.data.province, res.data.city, res.data.county]
            })
        },
        SubmitCustomer(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.row.province = this.detailData.row.area[0]
                    this.detailData.row.city = this.detailData.row.area[1]
                    this.detailData.row.county = this.detailData.row.area[2]
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/customer_add',
                        params: this.detailData.row
                    }).then(res => {
                        this.detailData.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.detailData.state.edit = false
                            this.GetCustomer()
                            if (this.detailData.state.active === '1') {
                                this.GetGrowing()
                            }
                        }
                    })
                }
            })
        },
        // 合作
        DetailCooperation() {
            this.detailData.state.edit = false
            this.componentParam.cooperationForm = {
                visible: true,
                row: {
                    customer_id: this.detailData.row.id,
                    customer_type_id: this.detailData.row.customer_type_id,
                    province: this.detailData.row.province,
                    city: this.detailData.row.city,
                    county: this.detailData.row.county
                }
            }
        },
        GetGrowing() {
            this.detailData.loading.side = true
            this.$request({
                url: '/api/v1/customer_growing_up',
                params: {
                    customer_id: this.detailParam.row.customer_id,
                    ...this.growingData.pages
                }
            }).then(res => {
                this.detailData.loading.side = false
                this.growingData.list = res.data.list
            })
        },
        SubmitFollow(data) {
            const communicate_record = data.communicate_record || this.followData.row.communicate_record
            if (communicate_record.indexOf('有效') > -1 || communicate_record.indexOf('无效') > -1) {
                this.$request({
                    url: '/api/v1/customer_follow_add',
                    params: {
                        customer_id: this.detailParam.row.customer_id,
                        communicate_record
                    }
                }).then(res => {
                    this.$message({
                        message: res.message || (res.status ? '操作失败' : '操作成功'),
                        type: res.status ? 'error' : 'success'
                    })
                    if (!res.status) {
                        this.followData.row.communicate_record = null
                        this.GetGrowing()
                    }
                })
            } else {
                this.$message({
                    message: '跟进内容须包含有效，无效！',
                    type: 'error'
                })
            }
        },
        // 任务
        DetailTask() {
            this.componentParam.visitForm = {
                visible: true,
                row: {
                    customer_id: this.detailParam.row.customer_id
                }
            }
        },
        GetTask() {
            this.$request({
                url: '/api/v1/customer_visit_one',
                params: {
                    customer_id: this.detailParam.row.customer_id,
                    ...this.taskData.pages
                }
            }).then(res => {
                this.taskData.list = res.data.list
            })
        },
        StateTask(row) {
            row.status = !row.status
            this.$request({
                url: row.status ? '/api/v1/customer_follow_add' : '/api/v1/delvisite',
                params: {
                    customer_id: this.detailParam.row.customer_id,
                    visit_id: row.id,
                    communicate_record: row.visit_remind_memo
                }
            }).then(res => {
                this.$message({
                    message: res.message || (res.status ? '操作失败' : '操作成功'),
                    type: res.status ? 'error' : 'success'
                })
            })
        },
        // 订单
        DetailOrder(row) {
            if (!row.id && !row.order_status_id) {
                // 创建订单
                this.componentParam.orderForm = {
                    visible: true,
                    row: {
                        id: row.id || null,
                        customer_id: this.detailParam.row.customer_id,
                        province: this.detailData.row.province,
                        city: this.detailData.row.city,
                        county: this.detailData.row.county,
                        address: this.detailData.row.address
                    }
                }
            } else {
                if (
                    row.order_status_id === 0 &&
                    (this.$store.state.userInfo.id === this.detailData.row.owner_id ||
                        this.$store.state.userInfo.id === row.order_user.id)
                ) {
                    /**
                     * 修改订单
                     * 订单状态（0 => 新订单）
                     * 登录用户是客户拥有者或订单创建者
                     */
                    this.componentParam.orderForm = {
                        visible: true,
                        row: {
                            id: row.id || null,
                            customer_id: this.detailParam.row.customer_id,
                            province: this.detailData.row.province,
                            city: this.detailData.row.city,
                            county: this.detailData.row.county,
                            address: this.detailData.row.address
                        }
                    }
                } else {
                    // 查看订单
                    this.componentParam.orderDetail = {
                        visible: true,
                        row: {
                            id: row.id
                        }
                    }
                }
            }
        },
        GetOrder() {
            this.$request({
                url: '/api/v1/order',
                params: {
                    customer_id: this.detailParam.row.customer_id,
                    ...this.orderData.pages
                }
            }).then(res => {
                this.orderData.list = res.data.list
            })
        },
        StateOrder(id, status) {
            switch (status) {
                case 3 || 41:
                    this.$prompt(null, '原因', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    })
                        .then(({ value }) => {
                            this.StateOrderFn(id, status, value)
                        })
                        .catch(() => {})
                    break
                case 40:
                    this.$confirm('客户已经收到货, 确定吗？', '警告', {
                        confirmButtonText: '确 定',
                        cancelButtonText: '取 消'
                    })
                        .then(() => {
                            this.StateOrderFn(id, status)
                        })
                        .catch(() => {})
                    break
                default:
                    this.$confirm('修改订单状态, 确定继续吗？', '警告', {
                        confirmButtonText: '确 定',
                        cancelButtonText: '取 消'
                    })
                        .then(() => {
                            this.StateOrderFn(id, status)
                        })
                        .catch(() => {})
                    break
            }
        },
        StateOrderFn(id, status, reason) {
            this.$request({
                url: '/api/v1/order_status',
                params: {
                    id: id,
                    status: status,
                    cancel_reason: reason || null
                }
            }).then(res => {
                this.$message({
                    message: res.message || (res.status ? '操作失败' : '操作成功'),
                    type: res.status ? 'error' : 'success'
                })
                if (!res.status) {
                    switch (this.detailData.state.active) {
                        case '1':
                            this.GetGrowing()
                            break
                        case '3':
                            this.GetOrder()
                            break
                        default:
                            this.reload()
                            break
                    }
                }
            })
        },
        // 物流
        DetailExpress(row) {
            this.componentParam.orderExpress = {
                visible: true,
                row: {
                    // express_number: '1111111111'
                    express_number: row.order_logistics_info[0].number
                }
            }
        },
        // 呼叫
        GetCall(num) {
            this.$confirm('请稍候，我们将马上接通您的电话, 请注意接听！', '进行呼叫？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.$request({
                        url: '/api/v1/getsign',
                        params: {
                            passiveNum: num
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.message ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                    })
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
@import '~@/assets/css/process.less';
.el-tag {
    margin-right: 6px;
    cursor: pointer;
}
</style>
